import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import './custom.css'

const isAndroid = navigator.userAgent.toLowerCase().includes("android") || navigator.userAgent.toLowerCase().includes("samsungbrowser");
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

const Promo = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  useEffect(() => {
    if (!code) return;

    // Build the store URLs with parameters
    const androidStoreUrl = `https://play.google.com/store/apps/details?id=com.Solen.OzmoAdventureLandMain&referrer=utm_source%3Dpromo%26code%3D${code}`;
    const iosStoreUrl = `https://apps.apple.com/app/id6451192799?code=${code}`;
    const appScheme = `ozmoadventureland://promo?code=${code}`;
    const start = Date.now();
    const timeout = 2000;

    if (isIOS) {
      // For iOS: Universal Links handle app opening automatically via AASA file
      // If app is installed, iOS will intercept the link and open the app (page won't load)
      // If app is NOT installed, this page loads, so redirect to App Store
      // Use a short delay to allow Universal Links to process first

      // Try to open the app
      window.location.href = appScheme;

      // Fallback to store if app is not opened
      const timer = setTimeout(() => {
        const elapsed = Date.now() - start;
        if (!document.hidden && elapsed < timeout + 500) {
          // App didn't open, redirect to store
          window.location.href = iosStoreUrl;
        }
      }, timeout);

      return () => clearTimeout(timer);
      
    } else if (isAndroid) {

      // Try to open the app
      window.location.href = appScheme;

      // Fallback to store if app is not opened
      const timer = setTimeout(() => {
        const elapsed = Date.now() - start;
        if (!document.hidden && elapsed < timeout + 500) {
          // App didn't open, redirect to store
          window.location.href = androidStoreUrl;
        }
      }, timeout);

      return () => clearTimeout(timer);
    }
  }, [code]);

  return (
    <div className="p-10 min-h-screen flex items-center justify-center" style={{padding: '10px'}}>
      <div className="flex flex-col items-center px-6 py-24 space-y-8 w-full max-w-md" style={{padding: '10px'}}>
        <img
          className="max-w-full h-auto"
          src="/logo.png"
          width={212}
          height={54}
          alt="ozmo"
        />

        <div className="w-full border-t border-gray-200" />

        <div className="text-center text-white text-base font-medium leading-snug">
          {code ? `Promo kodunuz: ${code}` : "Uygulamaya yönlendiriliyorsunuz..."}
        </div>

        {isAndroid ? (
          <a
            href={`https://play.google.com/store/apps/details?id=com.Solen.OzmoAdventureLandMain${code ? `&referrer=utm_source%3Dpromo%26code%3D${code}` : ''}`}
            className="flex justify-center"
          >
            <img
              src="/img/get-on-the-google-play-badge-tr.png"
              alt="GooglePlay"
              className="w-40 h-auto"
            />
          </a>
        ) : (
          <a
            href={`https://apps.apple.com/app/id6451192799${code ? `?code=${code}` : ''}`}
            className="flex justify-center"
          >
            <img
              src="/img/download-on-the-app-store-badge-tr.svg"
              alt="AppStore"
              className="w-40 h-auto"
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default Promo;

